import React, { useEffect } from "react";
import { notifyError, notifySuccess, saveAuthToken } from "../utils/helper";
import { authenticateUser } from "../requests";
import { useDispatch } from "react-redux";
import { resetPage } from "../_store/reducers/pageChangeReducer";
import { persistLanguage } from "../_components/common/LanguageSwitcher";

function Authenticate() {
  const dispatch = useDispatch();

  useEffect(() => {
    // Extract sal_token from URL query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const salToken = urlParams.get("sal_token");
    
    // If sal_token exists, store it in sessionStorage
    handleAuthenticateUser(salToken);
    
  }, []);

  const handleAuthenticateUser = async (token) => {
    if (!token) window.location.href = "/";
    try {
      const response = await authenticateUser({
        sal_token: token,
      });
      if (response.status === 200) {
        const userInfo = response.data.user;
        sessionStorage.setItem("sal_userInfo", JSON.stringify(userInfo));
        notifySuccess(response.data.message);
        localStorage.removeItem("page");
        saveAuthToken(response.data.token);
        // Sync current UI language to DB on login (e.g. guest choice before first auth)
        const language = localStorage.getItem("language") || "en";
        await persistLanguage(language);
      }
    } catch (error) {
      console.log(error);
      if (error.response && error.response.status === 401) {
        notifyError(error.response.data.message);
      } else if (error.response) {
        notifyError(error.response.data.message);
      } else {
        notifyError("Something went wrong");
      }
    }
    window.location.href = "/";
  };
  return <div>Authenticating...</div>;
}

export default Authenticate;
